/* hs-eslint ignored failing-rules */

/* eslint-disable prefer-promise-reject-errors */
import enviro from 'enviro';
import apiClient from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'Raven';
import { Data } from '../signup-data/DATA';
import { getHublet } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
import { updateWordpressAuthResponse } from '../store/integrations/action-creators';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { APP_SCOPES } from 'wordpress-scopes';
const CLIENT_IDS = {
  qa: '5441b9e5-b561-451b-b3bc-5340bd8bf41e',
  prod: '6fde4e11-cbcf-4f7c-b1ba-8f57e9b02ae8'
};

const getClientId = () => enviro.isQa() ? CLIENT_IDS.qa : CLIENT_IDS.prod;

const getOauthRedirectUrl = hublet => {
  const baseRedirect = getFullUrl('app-api', {
    hubletOverride: hublet
  });
  return `${baseRedirect}/wordpress/v1/oauth/callback`;
};

export const authorizeWordpress = ({
  recaptchaToken,
  hubId,
  hublet,
  dispatch
}) => {
  const data = {
    clientId: getClientId(),
    recaptchaToken,
    hubId,
    redirectUri: getOauthRedirectUrl(hublet),
    responseType: 'code',
    scopes: APP_SCOPES
  };
  const oauthApiPath = `/oauth/v1/auth?portalId=${hubId}`;
  return apiClient.post(`${getFullUrl('app-api', {
    hubletOverride: hublet
  })}${oauthApiPath}`, {
    data
  }).then(response => apiClient.post(`${response.redirectUri}&portalId=${hubId}`)).then(response => {
    dispatch(updateWordpressAuthResponse(response));
  });
};
export const makeWordpressAuthorizationRequest = (state, dispatch) => {
  const hubId = getPortalId(state);

  if (!hubId) {
    Raven.captureMessage('No portalId found in state.');
    return Promise.reject();
  }

  const recaptchaToken = getSignupDataValue(state, Data.WordpressRecaptchaToken);
  const hublet = getHublet(state);
  return authorizeWordpress({
    recaptchaToken,
    hubId,
    hublet,
    dispatch
  });
};
export const validateOAuthPermissions = state => {
  const hubId = getPortalId(state);
  const hublet = getHublet(state);
  const baseApi = `${getFullUrl('app-api', {
    hubletOverride: hublet
  })}`;
  return apiClient.post(`${baseApi}/oauth/v1/application-authorizations?portalId=${hubId}`, {
    data: {
      clientId: getClientId(),
      hubId,
      redirectUri: getOauthRedirectUrl(hublet),
      responseType: 'code',
      scopes: APP_SCOPES
    }
  });
};